export const RC_SKU_LINEUP = "sku_lineup";
export const RC_DOWNLOAD_TAB = "download_tab";
export const RC_FEED_FEATURE = "manager_feed_feature";
